// axios
import axios from "axios";

// const baseURL = "https://brained-whatsapp-uat-api.aiab.in/";
const baseURL = process.env.VUE_APP_WHATSAPP_URL;
// const baseURL = "http://localhost:3001/";

const API = axios.create({
  baseURL,
  // You can add your headers here
});

API.interceptors.request.use(
  (config) => {
    const community = localStorage.getItem("community");

    // if (community) {
    config.headers["community-name"] = "brained";
    // config.headers["Content-Type"] = "multipart/form-data";
    // }
    return config;
  },
  (error) => Promise.reject(error)
);

export default API;
